import { numberMoney } from 'Data/format.js'
import { getTotalDeductibleAmount } from 'Data/payment-plan.js'

export function getValue(insurance, treatment_plan) {
  return numberMoney(getTotalDeductibleAmount(insurance, treatment_plan))
}
